var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.containRoles(_vm.roles) && _vm.containPermissions(_vm.permissions))?_c('div',[_vm._t("default")],2):_c('div',{staticClass:"not-allow-wrap"},[_vm._t("not-allow",function(){return [_c('NotAllow')]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }